// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hamburger[data-v-64757d20] {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  width: 20px;\r\n  height: 20px;\n}\n.hamburger.is-active[data-v-64757d20] {\r\n  -webkit-transform: rotate(180deg);\r\n          transform: rotate(180deg);\n}\r\n", ""]);
// Exports
module.exports = exports;
